export const userActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    USER_LOADED: 'USER_LOADED'
}